import { render, staticRenderFns } from "./ProjectForums.vue?vue&type=template&id=5eb470dc&scoped=true&"
import script from "./ProjectForums.vue?vue&type=script&lang=js&"
export * from "./ProjectForums.vue?vue&type=script&lang=js&"
import style0 from "./ProjectForums.vue?vue&type=style&index=0&id=5eb470dc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eb470dc",
  null
  
)

export default component.exports